/* eslint-disable */
import { ClientApplication } from '../msal/clientApp';
import { handleErrorResponse } from './problemDetails';


class BaseClient {
    public isAnonymous: boolean = false;

    protected async transformOptions(options_: RequestInit): Promise<RequestInit> {
        if (this.isAnonymous) {
            return options_;
        }

        try {
            const tokenResponse = await ClientApplication.getAccessTokenSilently([]);

            if (tokenResponse) {
                return Promise.resolve({
                    ...options_,
                    headers: {
                        ...options_.headers,
                        "Authorization": `Bearer ${tokenResponse}`
                    },
                    mode: 'cors',
                    credentials: 'omit'
                });
            }
            else {
                console.error('Token not found');
                return Promise.reject();
            }
        }
        catch (e) {
            return Promise.reject(e);
        }

    }

    protected async transformResult(url: string, response: Response, processor: (response: Response) => any): Promise<any> {
        const clone = response.clone();
        if (!clone.ok) {
            await handleErrorResponse(response);
        }
        return processor(response);
    }

    public getBaseUrl(arg0: string, baseUrl: string | undefined): string {
        return process.env.NODE_ENV === 'development' ? 'https://localhost:44333' : '';
    }
}

export default BaseClient;